export default "__VITE_ASSET__p_k41PcK__"